import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTheme } from "@mui/material/styles";

const BarChart = ({ series, categories, color }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";

    const defaultSeries = [
        {
            data: [2100, 2200, 1000, 2800, 1600, 2100, 1300, 3200, 1300, 3000, 1300, 3000],
        },
    ];
    const defaultCategories = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const chartSeries = series || defaultSeries;
    const chartCategories = categories || defaultCategories;

    // Use theme colors
    const barColor = color || theme.palette.primary.main;
    const labelColor = theme.palette.text.secondary;
    const ttTheme = isDark ? "dark" : "light";

    const options = {
        chart: {
            type: "bar",
            toolbar: {
                show: false,
            },
            background: "transparent",
        },
        colors: [barColor],
        plotOptions: {
            bar: {
                columnWidth: "45%",
                distributed: true, // If we want different colors per bar, set this to true and provide array of colors. For now, single color.
                borderRadius: 4,
            },
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        xaxis: {
            categories: chartCategories,
            labels: {
                style: {
                    colors: Array(chartCategories.length).fill(labelColor),
                    fontSize: "12px",
                    fontFamily: theme.typography.fontFamily,
                },
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: [labelColor],
                    fontSize: "12px",
                    fontFamily: theme.typography.fontFamily,
                },
                formatter: (val) => {
                    return val >= 1000 ? `${(val / 1000).toFixed(1)}k` : val;
                }
            },
        },
        grid: {
            borderColor: theme.palette.divider,
            strokeDashArray: 4,
        },
        tooltip: {
            theme: ttTheme,
            y: { formatter: (val) => `${val}` },
        },
        responsive: [
            {
                breakpoint: 768,
                options: {
                    plotOptions: { bar: { columnWidth: "60%" } },
                },
            },
        ],
    };

    return (
        <div style={{ width: "100%", height: "100%", minHeight: "300px" }}>
            <ReactApexChart
                options={options}
                series={chartSeries}
                type="bar"
                width="100%"
                height="100%"
            />
        </div>
    );
};

export default BarChart;
